var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 101,
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_4072_4571)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    transform: "translate(0 0.626953)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5348 126.288L85.5658 118.266L51.5378 93.4883L40.4956 101.556L74.5348 126.288Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 82.0915L113.758 69.1338L79.7183 93.8942L83.9999 106.88L118 82.0915Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7383 109.088L43.7523 117.133L56.941 77.1674L45.8819 69.1167L32.7383 109.088Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4907 98.6719L29.4935 106.717L42.6878 66.7509L31.6287 58.7002L18.4907 98.6719Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2084 53.748L18 66.7114L60.09 66.7733L64.2815 53.7593L22.2084 53.748Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6567 36.959L23.4482 49.928L65.5325 49.9899L69.7297 36.9759L27.6567 36.959Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6454 26.627H58.0117L70.9469 66.6775L84.6144 66.6549L71.6454 26.627Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2959 26.627H75.6621L88.5973 66.6775L102.271 66.6549L89.2959 26.627Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8108 115.9L99.8304 107.877L65.808 83.1055L54.7715 91.1674L88.8108 115.9Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.501 65.32L108.254 52.3623L74.2256 77.1228L78.5016 90.103L112.501 65.32Z",
    fill: "#EDEDED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4072_4571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0 0.626953)"
  })))));
};
export default SvgIcon;